import React from "react";

export default function useIsActive(htmlElement) {
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => {
    if (htmlElement == null) return;

    function onMouseDown() {
      setIsActive(true);
    }
    function onMouseUp() {
      setIsActive(false);
    }

    htmlElement.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);

    return () => {
      setIsActive(false);
      htmlElement.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [htmlElement]);

  return Boolean(htmlElement) ? isActive : false;
}
